import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 9a5 5 0 0 0 -5 -5h-2a5 5 0 0 0 -5 5v6a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5","key":"svg-0"}]]

const IconLetterC = createReactComponent('outline', 'letter-c', 'LetterC', __iconNode);

export default IconLetterC;